<div class="dialog-form user-access">
  <p class="subtitle" *ngIf="userName">
    <i class="pi pi-user"></i>
    Permissões de <strong>{{ userName }}</strong> nesta marina
  </p>

  <div class="profile-cards">
    <button type="button" class="profile-card" *ngFor="let opt of profileOptions"
            [class.active]="profile === opt.value" (click)="selectProfile(opt.value)">
      <span class="pc-check" *ngIf="profile === opt.value"><i class="pi pi-check"></i></span>
      <i class="pc-icon pi" [ngClass]="opt.icon"></i>
      <span class="pc-title">{{ opt.title }}</span>
      <span class="pc-sub">{{ opt.subtitle }}</span>
    </button>
  </div>

  <div class="capabilities" *ngIf="isCustom">
    <div class="category" *ngFor="let group of categories">
      <div class="category-header">
        <span class="category-name">
          <i class="pi" [ngClass]="categoryIcon(group.name)"></i>
          {{ categoryLabel(group.name) }}
          <span class="category-count">{{ selectedCount(group) }}/{{ group.caps.length }}</span>
        </span>
        <span class="category-actions">
          <button type="button" class="link-btn" pTooltip="Marcar tudo" tooltipPosition="top"
                  (click)="toggleCategory(group, true)">
            <i class="pi pi-check-circle"></i>
          </button>
          <button type="button" class="link-btn" pTooltip="Limpar" tooltipPosition="top"
                  (click)="toggleCategory(group, false)">
            <i class="pi pi-circle"></i>
          </button>
        </span>
      </div>
      <div class="capability-grid">
        <label class="capability" *ngFor="let cap of group.caps" [class.checked]="selected[cap.code]">
          <p-checkbox [binary]="true" [(ngModel)]="selected[cap.code]" [name]="cap.code"></p-checkbox>
          <span class="capability-label">{{ cap.description }}</span>
        </label>
      </div>
    </div>
  </div>

  <div class="buttons">
    <button class="easymarine danger" type="button" (click)="ref.close()">
      <i class="pi pi-times"></i> {{ 'CANCEL' | translate }}
    </button>
    <button class="easymarine primary" type="button" (click)="save()">
      <i class="pi pi-check"></i> {{ 'SAVE' | translate }}
    </button>
  </div>
</div>
